<template>
  <section class="order-item">
    <div class="hd">
      <h2 class="title">{{data.seller && data.seller.nickName}}</h2>
      <aside
        class="tools"
        v-if="data.tradeInfo.tradeState === 'SUCCESS'"
      >{{data.tradeInfo.tradeCompleteTime | formatDate}}</aside>
      <aside class="tools" v-else>{{data.tradeInfo.tradeState | getTradeStatus}}</aside>
    </div>
    <div class="bd goods">
      <router-link :to="`/my/order/item/${data.tradeInfo.id}`">
        <good-item v-for="item in data.tradeItemList" :data="item" :key="item.id"></good-item>
      </router-link>
    </div>
    <template v-if="data.tradeInfo.trandeType !==2 || data.tradeInfo.trandeType !==3">
      <div class="ft">
        <div class="text">
          <p class="t1">
            <template v-if="data.tradeInfo.tradeState === 'WAIT_PAY'">需付款：</template>
            <template v-else-if="data.tradeInfo.tradeState === 'CANCEL'">已取消：</template>
            <template v-else>实付：</template>
          </p>
          <h4 class="price" v-html="getPriceCreditHtml(data.tradeInfo.payAmount,data.tradeInfo.creditAmount)"></h4>
        </div>
        <div class="buttons" v-if="data.tradeInfo.tradeState === 'WAIT_PAY'">
          <input type="button" class="btn btn-order-cancel" value="取消订单" @click="onCancelOrder(data.tradeInfo.id)">
          <input type="button" class="btn btn-order-pay" value="立即支付" @click="onPay">
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import queryString from 'query-string'
import {
  getTradeStatus,
  formatDateTime,
  getPriceCreditHtml
} from '@/utils/utils'
import { closeOrder } from '@/api/order'
import GoodItem from './GoodItem'

export default {
  name: 'OrderItem',
  components: { GoodItem },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  filters: {
    getTradeStatus: getTradeStatus,
    formatDate: formatDateTime
  },
  methods: {
    getPriceCreditHtml,
    // 取消订单之前
    onCancelOrder(id) {
      this.$messagebox({
        title: '确认要取消订单？',
        message: '订单取消后将直接被删除，如需购买请重新下单。',
        showCancelButton: true,
        confirmButtonText: '确认'
      }).then(action => {
        if (action === 'confirm') {
          this.cancelOrder(id)
        }
      })
    },
    // 取消订单
    cancelOrder(id) {
      closeOrder({ tradeId: id }).then(response => {
        this.$emit('update')
      })
    },
    onPay() {
      let query = queryString.stringify({
        trade_id: this.data.tradeInfo.id,
        open_id: this.data.buyer.openIdStr
      })
      location.href = `${process.env.VUE_APP_WEBAPP_PAY_URL}/?${query}`
    }
  }
}
</script>
